module.exports = __webpack_public_path__ + "img/1476315316.4169bd0a.jpg";